/**
 * Public-facing Langfuse base URL the dashboard links out to.
 *
 * This is a single-source-of-truth used by every component that emits an
 * "open in Langfuse" link. Hard-coded because the dashboard frontend cannot
 * read env at runtime (Vite would inline `import.meta.env.VITE_*` at build
 * time, baking the value in either way) and the URL is not secret.
 *
 * The trailing slash is normalized so callers can `${BASE}${traceId}` without
 * worrying about double-slash artifacts. Update this single constant if
 * Langfuse is ever moved.
 */
export const LANGFUSE_TRACE_BASE = (
  import.meta.env.VITE_LANGFUSE_BASE ??
  'https://langfuse.botsfleet.online/trace/'
).replace(/\/?$/, '/');

/** Build a canonical trace URL from a traceId. */
export function langfuseTraceUrl(traceId: string): string {
  return `${LANGFUSE_TRACE_BASE}${encodeURIComponent(traceId)}`;
}
